import http from "../utils/http";

import config from "../config";
import { FormikValues } from "formik";

/**
 * Get all
 **/
const getById = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.patient.getById(id)}`;
  return http.get(url);
};

const getByIdForReferral = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.patient.getById(id)}?reReferralPatient=true`;
  return http.get(url);
};

const create = async (payload: FormikValues) => {
  const url = `${config.baseUrl}${config.endPoints.patient.add}`;
  return http.post(url, payload);
};

const update = async (id: string, body: any) => {
  const url = `${config.baseUrl}${config.endPoints.patient.update(id)}`;
  return http.put(url, body);
};

const deletePatient = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.patient.delete(id)}`;
  return http.delete(url);
};

const addReferral = async (payload: FormikValues) => {
  const url = `${config.baseUrl}${config.endPoints.patient.addReferral(
    payload.patientId
  )}`;
  return http.post(url, payload);
};

const search = async (
  pageNo: number,
  pageSize: number,
  filterValues?: {
    status?: string[];
    keyword?: string;
    district?: string;
    createdBy?: string[];
    approvedBy?: string[];
    startDate?: string;
    endDate?: string;
  }
) => {
  const url = `${config.baseUrl}${config.endPoints.patient.search(
    pageNo,
    pageSize
  )}`;

  return http.post(url, filterValues);
};

const filter = async () => {
  const url = `${config.baseUrl}${config.endPoints.patient.getFilter}`;
  return http.get(url);
};

const canUpdate = async (submittedAt: string) => {
  const url = `${config.baseUrl}${config.endPoints.patient.canUpdate(
    submittedAt
  )}`;
  return http.get(url);
};

const report = async (type: string, from: string, to: string) => {
  const url = `${config.baseUrl}${config.endPoints.patient.exportCSV(
    type,
    from,
    to
  )}`;
  return http.get(url);
};

const patientService = {
  getById,
  create,
  update,
  delete: deletePatient,
  search,
  filter,
  canUpdate,
  report,
  addReferral,
  getByIdForReferral,
};

export default patientService;
